import { Button } from "react-bootstrap";
import React from "react";
import './CustomButton.css';

interface CustomButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isLoading: boolean;
    onClick?: () => void;
    label: string;
    className?: string;
}

const CustomButton = ({ isLoading, onClick, label, className, ...rest }: CustomButtonProps) => {
    return (
        <Button className={`d-flex align-items-center justify-content-center button-custom ${className}`} onClick={onClick} disabled={isLoading} {...rest}>
            {isLoading && (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            )}
            {label}
        </Button>
    )
}

export default CustomButton;